import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { artifactStore, viewsStore, timStore } from "@/hooks";
import { PanelCard, TextButton } from "@/components/common";
import { ArtifactListDisplay } from "@/components/artifact/display";


/**
 * Displays the list of artifacts within the selected artifact level.
 */
const __default__ = {
  name: "ArtifactLevelArtifacts",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifactLevel = computed(() => timStore.selectedArtifactLevel);
const name = computed(() => artifactLevel.value?.name || "");

const artifacts = computed(() => artifactStore.getArtifactsByType(name.value));
const artifactsLabel = computed(() =>
  artifacts.value.length === 1
    ? "1 Artifact"
    : `${artifacts.value.length} Artifacts`
);

return (_ctx: any,_cache: any) => {
  return (artifacts.value.length > 0)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: artifactsLabel.value,
        collapsable: "",
        borderless: ""
      }, {
        "title-actions": _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            small: "",
            label: "View Artifacts",
            icon: "view-tree",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).addDocumentOfTypes([name.value])))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(ArtifactListDisplay), {
            artifacts: artifacts.value,
            "data-cy": "list-selected-artifacts",
            "item-data-cy": "list-selected-artifact-item",
            class: "bg-background rounded",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(viewsStore).addDocumentOfNeighborhood($event)))
          }, null, 8, ["artifacts"])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})